import { Button, Loading } from '@orobix/orobix-fe-components'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { trainingTestWarningTreshold } from './const'
import { fetchCounter } from './utils'

const loadingIcon = <Loading />

type StartTrainingTestButtonProps = {
  isDisabled: boolean
  isLoading: boolean
  onSkipConfirmation: () => void
  onRequiresConfirmation: () => void
}

const StartTrainingTestButton = ({
  isDisabled,
  isLoading,
  onSkipConfirmation,
  onRequiresConfirmation,
}: StartTrainingTestButtonProps) => {
  const { t } = useTranslation()
  const [isFetching, setFetching] = useState(false)

  const handleClick = async () => {
    setFetching(true)
    const counter = await fetchCounter()
    setFetching(false)

    if (counter) {
      const usageOk =
        counter.currentValue / counter.threshold < trainingTestWarningTreshold
      const skipConfirmation = !counter.isEnabled || usageOk

      if (skipConfirmation) {
        onSkipConfirmation()
      } else {
        onRequiresConfirmation()
      }
    }
  }

  return (
    <div id="startTrainingTestButtonId">
      <Button
        label={t('Start a new test')}
        type="action"
        disabled={isDisabled || isFetching}
        icon={isLoading || isFetching ? loadingIcon : null}
        onClick={(e) => {
          e.preventDefault()
          handleClick()
        }}
      />
    </div>
  )
}

export default StartTrainingTestButton
